import { Logtail } from "@logtail/browser"
import config from "../config.json"

const LOGTAIL_SOURCE_TOKENS = {
  staging: "BB8f5pTAcMkTwv72zmi5CWnc",
  production: "jJEKB7sjACknCUBb1VZqjzEd"
}
const LOGTAIL_ENDPOINTS = {
  staging: "https://s1706874.eu-fsn-3.betterstackdata.com",
  production: "https://s1534938.eu-nbg-2.betterstackdata.com"
}
const LOGTAIL_SOURCE_TOKEN = config.environment === "production" ? LOGTAIL_SOURCE_TOKENS.production : LOGTAIL_SOURCE_TOKENS.staging
const LOGTAIL_ENDPOINT = config.environment === "production" ? LOGTAIL_ENDPOINTS.production : LOGTAIL_ENDPOINTS.staging

const logtail = new Logtail(LOGTAIL_SOURCE_TOKEN, {
  endpoint: LOGTAIL_ENDPOINT,
})

class Logger {
  static info(message, metadata = {}) {
    logtail.info(message, {
      ...metadata,
      environment: config.environment
    })
  }

  static error(message, metadata = {}) {
    logtail.error(message, {
      ...metadata,
      environment: config.environment
    })
  }

  static warn(message, metadata = {}) {
    logtail.warn(message, {
      ...metadata,
      environment: config.environment
    })
  }

  static debug(message, metadata = {}) {
    logtail.debug(message, {
      ...metadata,
      environment: config.environment
    })
  }

  static flush() {
    return logtail.flush()
  }
}

export default Logger
